export enum EasmSideMenuEvents {
  OPEN_FINDING_DETAILS = 'openFindingDetails',
  OPEN_FINDING_RELATED = 'openFindingRelated',
  OPEN_NOTES = 'openNotes',
  CLOSE_SIDE_MENU = 'closeSideMenu',
}
